import React, { ReactNode, useMemo } from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ButtonExport } from './ButtonExport'
import Chart, { ReactGoogleChartProps } from 'react-google-charts'
import LoadingPage from '../../../Other/LoadingPage'
import { NoData } from '../../../../components/GoogleChart/ChartComponent'

export const Report: React.FC<ReportProps> = ({
    title,
    loading,
    onExportCSV,
    exportDisabled = false,
    exportLabel,
    exportIcon,
    className,
    chart,
    children,
}) => {
    const headingId = useMemo(
        () => (title ? `report-title-${Math.random().toString(36).slice(2)}` : undefined),
        [title]
    )

    const hasHeader = Boolean(title)
    const showExport = Boolean(onExportCSV)

    const isLoading = Boolean(loading)
    const hasData = Boolean(chart?.data && Array.isArray(chart.data) && chart.data.length > 1)

    const content = isLoading ? (
        <LoadingPage />
    ) : (
        (children ??
        (hasData ? (
            <div style={{ borderRadius: '5px', overflow: 'hidden' }}>
                <Chart {...chart} />
            </div>
        ) : (
            <NoData />
        )))
    )

    return (
        <section className="chart" role="region" aria-labelledby={headingId} aria-busy={isLoading}>
            {hasHeader && (
                <header className="report-header">
                    <h4 id={headingId as string}>{title}</h4>
                    {showExport && (
                        <ButtonExport
                            onClick={onExportCSV as () => void}
                            disabled={!!exportDisabled || isLoading || !hasData}
                            label={exportLabel}
                            icon={exportIcon}
                        />
                    )}
                </header>
            )}
            <div className={className ?? 'report-display'}>{content}</div>
        </section>
    )
}

export type ReportProps = {
    title?: string | ReactNode
    chart?: ReactGoogleChartProps
    children?: ReactNode

    loading?: boolean
    onExportCSV?: () => void
    exportDisabled?: boolean
    exportLabel?: string
    exportIcon?: IconProp
    className?: string
}
